import React, { useState } from 'react';

// Crack the Vault — a unique risk game. Wager coins, smash machines one by one.
// Each safe smash raises your multiplier; one machine hides a SILENT ALARM.
// Cash out anytime — or hit the alarm and lose the wager.
const WAGERS = [100, 250, 500, 1000];
const MULTS = [1.3, 1.7, 2.2, 3, 4.5, 7];
const GRID = 6;

export default function VaultCrack({ profile, onChange, onClose }) {
  const [wager, setWager] = useState(100);
  const [state, setState] = useState('bet'); // bet | play | bust | won
  const [alarm, setAlarm] = useState(-1);
  const [revealed, setRevealed] = useState([]);
  const [step, setStep] = useState(0);

  const coins = profile.coins || 0;
  const mult = step > 0 ? MULTS[Math.min(step - 1, MULTS.length - 1)] : 1;
  const potential = Math.round(wager * mult);

  const begin = () => {
    if (coins < wager) return;
    onChange({ coins: coins - wager });
    setAlarm(Math.floor(Math.random() * GRID));
    setRevealed([]); setStep(0); setState('play');
  };

  const pick = (i) => {
    if (state !== 'play' || revealed.includes(i)) return;
    const nr = [...revealed, i];
    setRevealed(nr);
    if (i === alarm) { setState('bust'); }
    else {
      const ns = step + 1;
      setStep(ns);
      if (ns >= GRID - 1) { cashOut(ns); } // cleared all safe machines
    }
  };

  const cashOut = (s = step) => {
    if (state !== 'play' || s < 1) return;
    const m = MULTS[Math.min(s - 1, MULTS.length - 1)];
    const win = Math.round(wager * m);
    onChange({ coins: (profile.coins || 0) + win });
    setState('won');
  };

  const reset = () => { setState('bet'); setRevealed([]); setStep(0); };

  return (
    <div className="so-overlay" onClick={onClose} data-testid="crack-modal">
      <div className="so-panel" onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <button className="so-panel-x" onClick={onClose} data-testid="crack-close">✕</button>
        <h2>💥 Crack the Vault</h2>
        <p className="so-store-sub">Smash machines to climb the multiplier. One hides a silent alarm — cash out before you get caught!</p>
        <div className="so-coins" data-testid="crack-balance">🪙 {profile.coins || 0}</div>

        {state === 'bet' && (
          <>
            <div className="so-crack-wagers">
              {WAGERS.map((w) => (
                <button key={w} className={'so-crack-wager' + (w === wager ? ' on' : '') + (coins < w ? ' dis' : '')}
                  onClick={() => coins >= w && setWager(w)} data-testid={'wager-' + w}>🪙 {w}</button>
              ))}
            </div>
            <button className="so-btn-play" onClick={begin} disabled={coins < wager} data-testid="crack-start">Place Bet & Smash</button>
          </>
        )}

        {state !== 'bet' && (
          <>
            <div className="so-crack-info">
              <span>Mult <b>x{mult}</b></span>
              <span>Cash value <b>🪙 {state === 'play' ? potential : 0}</b></span>
            </div>
            <div className="so-crack-grid" data-testid="crack-grid">
              {Array.from({ length: GRID }).map((_, i) => {
                const rev = revealed.includes(i);
                const isAlarm = i === alarm;
                const show = rev || state !== 'play';
                return (
                  <button key={i} className={'so-crack-cell' + (rev ? (isAlarm ? ' alarm' : ' safe') : '') }
                    onClick={() => pick(i)} disabled={state !== 'play'} data-testid={'crack-cell-' + i}>
                    {show ? (isAlarm ? '🚨' : (rev ? '💰' : '🏪')) : '🏪'}
                  </button>
                );
              })}
            </div>
            {state === 'play' && (
              <button className="so-btn-play" onClick={() => cashOut()} disabled={step < 1} data-testid="crack-cashout">
                Cash Out 🪙 {potential}
              </button>
            )}
            {state === 'bust' && (<><div className="so-crack-result bust" data-testid="crack-bust">🚨 CAUGHT! Lost 🪙 {wager}</div><button className="so-btn-play" onClick={reset} data-testid="crack-again">Try Again</button></>)}
            {state === 'won' && (<><div className="so-crack-result won" data-testid="crack-won">🎉 Cashed out 🪙 {Math.round(wager * MULTS[Math.min(step - 1, MULTS.length - 1)])}!</div><button className="so-btn-play" onClick={reset} data-testid="crack-again">Play Again</button></>)}
          </>
        )}
      </div>
    </div>
  );
}
